import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CommonModule } from "@angular/common";
import {
  ReactiveFormsModule,
  FormsModule,
  FormControl,
  Validators,
  FormGroup,
  Form,
  FormBuilder,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatTableModule, MatRowDef } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import CompanyAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company.entity";
import { CompanyService } from "../company/company.service.service";
import { MatTabsModule } from "@angular/material/tabs";
import { MatBadgeModule } from "@angular/material/badge";
import {
  NgLabelTemplateDirective,
  NgSelectComponent,
  NgSelectModule,
} from "@ng-select/ng-select";
import { PlantsService } from "../plant/plants.service";
import { ICreateSalesOffice } from "./interfaces/create-sales-office.interface";
import {
  IUpdateSalesOffice,
  UpdateSalesOfficeAddress,
} from './interfaces/update-sales-office.interface';
import { SalesOfficeService } from './sales-office.service';
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import DistributionChainAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/distribution-chain/distribution-chain.entity';
import DivisionAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/division/division.entity';
import OfficeGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/office-group/office-group.entity';
import { WarehouseAttributes } from '@albatrosdeveloper/ave-models-package';
import { WarehouseService } from '../warehouse/warehouse.service';
import { DistributionChainService } from '../distribution-chain/distribution-chain.service';
import { DivisionService } from '../division/division.service.service';
import { OfficeGroupService } from '../office-group/office-group.service';
import { SalesOfficeTypeEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/sales-office-type.enum';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { ReplaySubject, Subject, Subscription, take, takeUntil, firstValueFrom, BehaviorSubject, startWith, map } from 'rxjs';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { TranslocoModule } from '@ngneat/transloco';
import { getCode } from 'app/utils/method';
import ChannelAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/channel/channel.entity';
import { ChannelService } from '../channel/channel.component.service';
import { ExportService } from 'app/layout/export-overlay/export-overlay.service';
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { ExportOptions } from 'app/layout/export-overlay/tasks/core/export-task.interfaces';
import { SalesOfficeExport } from './exports/sales-office.export';
import { SALES_OFFICE_TITLE } from './exports/sales-office.constants';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { IFilters } from '../../filters/interfaces/filterInterface';
import { HoverMenuDirective } from '@fuse/directives/hover-menu/hover-menu.directive';
import { FormSectionComponent } from 'app/shared/components/form-ui/form-section/form-section.component';
import AddressAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/address/address.entity';
import { SalesOfficeAddressFormComponent } from './sales-office-address-form/sales-office-address-form.component';
import { IAddressDTO } from './interfaces/address-dto.interface';
import { SalesOfficeEmailSectionComponent } from "./sales-office-email/sales-office-email-section.component";
import { SalesOfficePhoneSectionComponent } from "./sales-office-phone/sales-office-phone-section.component";
import { SalesOfficePhoneService } from "./sales-office-phone/sales-office-phone.service";
import { SalesOfficeEmailService } from "./sales-office-email/sales-office-email.service";
import PhoneAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/phone/phone.entity";
import EmailAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/email/email.entity";
import { BONUS_HANDLING_OPTIONS } from "app/shared/constants/lists.constant";

@Component({
  selector: "app-sales-office",
  standalone: true,
  templateUrl: "./sales-office.component.html",
  styleUrl: "./sales-office.component.scss",
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgSelectComponent,
    NgSelectModule,
    MatTabsModule,
    MatBadgeModule,
    NgxMatSelectSearchModule,
    TranslocoModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective,
    FormSectionComponent,
    SalesOfficeAddressFormComponent,
    SalesOfficeEmailSectionComponent,
    SalesOfficePhoneSectionComponent,
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    SalesOfficeExport,
  ],
})
export class SalesOfficeComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;

  displayedColumns: string[] = [
    "name",
    "officeGroup",
    "company",
    "address",
    "status",
    "actions",
  ];
  displayedColumnsEmail: string[] = ["email", "statusId", "actions"];
  displayedColumnsPhone: string[] = ["type", "prefix", "statusId", "actions"];
  bonusHandlingOptions = BONUS_HANDLING_OPTIONS;
  currentCreateSalesOffice: ICreateSalesOffice =
    this.initializeCreateSalesOffice();
  currentUpdateSalesOffice: SalesOfficeAttributes | undefined;

  dataSource: SalesOfficeAttributes[] = [];
  companyList: CompanyAttributes[] = [];
  selectedCompanyIds: string[] = [];
  salesOfficeType: { key: string; value: number }[] = [];
  divisionList: DivisionAttributes[] = [];
  warehouseList: WarehouseAttributes[] = [];

  channelList: ChannelAttributes[] = [];
  listFilterChannelList: ChannelAttributes[] = [];
  searchChannel = "";
  selectedChannel: ChannelAttributes = null;

  distributionChainList: DistributionChainAttributes[] = [];
  officeGroupList: OfficeGroupAttributes[] = [];
  searchQuery: string = "";
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 1;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit: MatDialogRef<any>;

  /** control for the selected routeArea for multi-selection */
  public warehouseMultiCtrl: FormControl<WarehouseAttributes[]> =
    new FormControl<WarehouseAttributes[]>([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public warehouseMultiFilterCtrl: FormControl<string> =
    new FormControl<string>("");

  /** list of warehouses filtered by search keyword */
  public filteredWarehouses: ReplaySubject<WarehouseAttributes[]> =
    new ReplaySubject<WarehouseAttributes[]>(1);

  /** local copy of filtered warehouses to help set the toggle all checkbox state */
  protected filteredWarehouseCache: WarehouseAttributes[] = [];

  /** control for the selected distributionchain for multi-selection */
  public distributionMultiCtrl: FormControl<DistributionChainAttributes[]> =
    new FormControl<DistributionChainAttributes[]>([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public distributionMultiFilterCtrl: FormControl<string> =
    new FormControl<string>("");

  /** list of distribution chain filtered by search keyword */
  public filteredDistribution: ReplaySubject<DistributionChainAttributes[]> =
    new ReplaySubject<DistributionChainAttributes[]>(1);

  /** local copy of filtered distribution chain to help set the toggle all checkbox state */
  protected filteredDistributionCache: DistributionChainAttributes[] = [];

  /** control for the selected division for multi-selection */
  public divisionMultiCtrl: FormControl<DivisionAttributes[]> = new FormControl<
    DivisionAttributes[]
  >([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public divisionMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of division filtered by search keyword */
  public filteredDivision: ReplaySubject<DivisionAttributes[]> =
    new ReplaySubject<DivisionAttributes[]>(1);

  /** local copy of filtered division  to help set the toggle all checkbox state */
  protected filteredDivisionCache: DivisionAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  /** flags to set the toggle all checkbox state */
  isIndeterminateDistrib = false;
  isCheckedDistrib = false;

  isIndeterminateDiv = false;
  isCheckedDiv = false;
  plants: any[] = [];

  form: FormGroup;
  selectedStatuses: number[] = []; // Activo, Inactivo

  // Lazy loading
  loadFiltersData = false;
  private companiesLoaded = false;
  private officeGroupsLoaded = false;
  private dataLoadedForModals = false;

  // Propiedades para validación de formularios
  isAddressValid: boolean | null = null; // null = no inicializado, true = válido, false = inválido
  isAddressFormInitialized: boolean = false;

  // DTO de dirección para creación y edición (evita conflictos de tipos)
  private currentCreateSalesOfficeAddress: UpdateSalesOfficeAddress | null =
    null;
  private currentUpdateSalesOfficeAddress: UpdateSalesOfficeAddress | null =
    null;

  // Propiedades para trackear tab seleccionado
  selectedCreateTabIndex: number = 0;
  selectedEditTabIndex: number = 0;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;
  protected _onDestroy = new Subject<void>();

  //BUSCADOR
  searchSubscription: Subscription;

  constructor(
    private plantService: PlantsService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly companyService: CompanyService,
    private readonly officegroupService: OfficeGroupService,
    private readonly warehouseService: WarehouseService,
    private readonly channelService: ChannelService,
    private readonly distributionService: DistributionChainService,
    private divisionService: DivisionService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public exportService: ExportService,
    private salesOfficeExport: SalesOfficeExport,
    private salesOfficePhoneService: SalesOfficePhoneService,
    private salesOfficeEmailService: SalesOfficeEmailService,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      companyId: [],
      salesOfficeGroupId: [],
    });
  }

  bonusFilterCtrl = new FormControl('');
filteredBonusOptions = new BehaviorSubject(this.bonusHandlingOptions);

ngOnInit() {
  this.bonusFilterCtrl.valueChanges
    .pipe(
      startWith(''),
      map(search => {
        const term = (search || '').toLowerCase();
        return this.bonusHandlingOptions.filter(opt =>
          opt.label.toLowerCase().includes(term)
        );
      })
    )
    .subscribe(filtered => {
      this.filteredBonusOptions.next(filtered);
    });
}

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private async ensureCompaniesLoaded(): Promise<void> {
    if (!this.companiesLoaded) {
      await this.fetchCompanies();
    }
  }

  private async ensureOfficeGroupsLoaded(): Promise<void> {
    if (!this.officeGroupsLoaded) {
      await this.fetchOfficeGroup();
    }
  }

  private async ensureModalDataLoaded(): Promise<void> {
    if (!this.dataLoadedForModals) {
      await this.initializeComboBox();
      this.dataLoadedForModals = true;
    }
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
    this.ensureCompaniesLoaded();
    this.ensureOfficeGroupsLoaded();
  }

  private initializeCreateSalesOffice(): ICreateSalesOffice {
    return {
      name: "",
      type: 0,
      companyid: "",
      officeGroupId: "",
      distributionChainId: "",
      distributionChainsInheritIds: [],
      divisionIds: [],
      warehouseIds: [],
      plantId: "",
      address: null,
    };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }
  getSelectedCompanyCodes(selectedCompanyIds: string[]): number[] {
    return selectedCompanyIds.map(
      (id) => this.companyList.find((group) => group._id.toString() === id)?.id
    );
  }

  findAllWithCount(): void {
    // const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";
    // const companyCodes = this.getSelectedCompanyCodes(this.selectedCompanyIds);
    let filter: IFilters = {
      companyId: this.form.get("companyId")?.value,
      salesOfficeGroupId: this.form.get("salesOfficeGroupId")?.value,
      status: this.selectedStatuses.length > 0 ? this.selectedStatuses : null,
    };

    this.salesOfficeService
      .findAllWithCount(
        {
          currentPage: this.pageIndex,
          limitPerPage: this.pageSize,
          search: this.searchQuery,
          sort: sortField,
          sortDirection: sortDirection,
        },
        filter
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof SalesOfficeAttributes {
    const validSortFields: (keyof SalesOfficeAttributes)[] = [
      "name",
      "statusId",
    ];
    return validSortFields.includes(
      this.sort.active as keyof SalesOfficeAttributes
    )
      ? (this.sort.active as keyof SalesOfficeAttributes)
      : "name";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      // this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$.subscribe(
      (term) => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.findAllWithCount();
        }
      }
    );
  }

  trackByFn(index: number, item: SalesOfficeAttributes): string {
    return item._id.toString();
  }

  async initializeComboBox(): Promise<void> {
    await Promise.all([
      this.fetchCompanies(),
      this.fetchAllChannel(),
      this.fetchAllDistributionChain(),
      this.fetchAllWarehouse(),
      this.fetchAllDivision(),
      this.fetchOfficeGroup(),
      this.loadPlants(),
    ]);

    this.salesOfficeType = Object.entries(SalesOfficeTypeEnum)
      .filter(([key, value]) => !isNaN(Number(value)))
      .map(([key, value]) => ({
        key,
        value: Number(value),
      }));
  }

  private async fetchOfficeGroup(): Promise<void> {
    try {
      const res = await firstValueFrom(this.officegroupService.findToComboBox());
      this.officeGroupList = res.data;
      this.officeGroupsLoaded = true;
    } catch (err: any) {
      this.snackBar.open(err.error?.message || 'Error al obtener grupos de oficinas.', 'Cerrar', {
        duration: 5000,
      });
    }
  }
  private async fetchAllDivision(): Promise<void> {
    try {
      const res = await firstValueFrom(this.divisionService.findToComboBox());
      this.divisionList = res.data;
      this.filteredDivision.next(this.divisionList);

      if (this.currentUpdateSalesOffice) {
        this.filteredDivision.pipe(take(1)).subscribe(materials => {
          const selectedMaterials = materials.filter(material =>
            this.currentUpdateSalesOffice.divisions
              .map((r) => r._id.toString())
              .includes(material._id.toString())
          );
          this.divisionMultiCtrl.setValue(selectedMaterials);
        });
      }

      // listen for search field value changes
      this.divisionMultiFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
        this.filterDivMulti();
        this.setToggleAllCheckboxStateDiv();
      });
    } catch (err: any) {
      this.snackBar.open(err.error?.message || 'Error al obtener divisiones.', 'Cerrar', {
        duration: 5000,
      });
    }
  }

  protected filterDivMulti() {
    if (!this.divisionList) {
      return;
    }
    // get the search keyword
    let search = this.divisionMultiFilterCtrl.value;
    if (!search) {
      this.filteredDivisionCache = this.divisionList;
      this.filteredDivision.next(this.divisionList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredDivisionCache = this.divisionList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredDivision.next(this.filteredDivisionCache);
  }

  toggleSelectAllDivision(selectAllValue: boolean) {
    this.filteredDivision
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.divisionMultiCtrl.patchValue(val);
        } else {
          this.divisionMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateDiv() {
    let filteredLength = 0;
    if (this.divisionMultiCtrl && this.divisionMultiCtrl.value) {
      this.filteredDivisionCache.forEach((el) => {
        if (this.divisionMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateDiv =
        filteredLength > 0 &&
        filteredLength < this.filteredDivisionCache.length;
      this.isCheckedDiv =
        filteredLength > 0 &&
        filteredLength === this.filteredDivisionCache.length;
    }
  }

  private async fetchAllWarehouse(): Promise<void> {
    try {
      const res = await firstValueFrom(this.warehouseService.findToComboBox());
      this.warehouseList = res.data;
      this.filteredWarehouses.next(this.warehouseList);

      if (this.currentUpdateSalesOffice) {
        this.filteredWarehouses.pipe(take(1)).subscribe(materials => {
          const selectedMaterials = materials.filter(material =>
            this.currentUpdateSalesOffice.warehouses
              .map((r) => r._id.toString())
              .includes(material._id.toString())
          );
          this.warehouseMultiCtrl.setValue(selectedMaterials);
        });
      }

      // listen for search field value changes
      this.warehouseMultiFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterWarehouseMulti();
          this.setToggleAllCheckboxStateWarehouse();
        });
    } catch (err: any) {
      this.snackBar.open(err.error?.message || 'Error al obtener almacenes.', 'Cerrar', {
        duration: 5000,
      });
    }
  }

  protected filterWarehouseMulti() {
    if (!this.warehouseList) {
      return;
    }
    // get the search keyword
    let search = this.warehouseMultiFilterCtrl.value;
    if (!search) {
      this.filteredWarehouseCache = this.warehouseList;
      this.filteredWarehouses.next(this.warehouseList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredWarehouseCache = this.warehouseList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      const plantMatches =
        material.plants &&
        material.plants.some((p) => p.name.toLowerCase().indexOf(search) > -1);
      return nameMatches || codeMatches || plantMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredWarehouses.next(this.filteredWarehouseCache);
  }

  toggleSelectAllWarehouse(selectAllValue: boolean) {
    this.filteredWarehouses
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.warehouseMultiCtrl.patchValue(val);
        } else {
          this.warehouseMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateWarehouse() {
    let filteredLength = 0;
    if (this.warehouseMultiCtrl && this.warehouseMultiCtrl.value) {
      this.filteredWarehouseCache.forEach((el) => {
        if (this.warehouseMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 &&
        filteredLength < this.filteredWarehouseCache.length;
      this.isChecked =
        filteredLength > 0 &&
        filteredLength === this.filteredWarehouseCache.length;
    }
  }

  private async fetchCompanies(): Promise<void> {
    try {
      const res = await firstValueFrom(this.companyService.findToComboBox());
      this.companyList = res.data;
      this.companiesLoaded = true;
    } catch (err: any) {
      this.snackBar.open(err.error?.message || 'Error al obtener compañias.', 'Cerrar', {
        duration: 5000,
      });
    }
  }

  private async fetchAllChannel(): Promise<void> {
    try {
      const res = await firstValueFrom(this.channelService.findToComboBox());
      this.channelList = res.data;
      this.listFilterChannelList = this.channelList.slice();
    } catch (err: any) {
      this.snackBar.open(
        err.error?.message || 'Error al obtener canal de distribución.',
        'Cerrar',
        { duration: 5000 }
      );
    }
  }

  changeOptionsChannel(event): void {
    if (!this.channelList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterChannelList = this.channelList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterChannelList = this.channelList.filter(
      (item) => item.name.toLowerCase().indexOf(search) > -1
    );
  }

  changeChannel() {
    this.distributionChainList = [];
    this.fetchAllDistributionChain();
  }

  private async fetchAllDistributionChain(): Promise<void> {
    try {
      const res = await firstValueFrom(this.distributionService.findToComboBox(this.selectedChannel));
      this.distributionChainList = res.data;
      this.filteredDistribution.next(this.distributionChainList);

      if (this.currentUpdateSalesOffice) {
        this.filteredDistribution.pipe(take(1)).subscribe(materials => {
          const selectedMaterials = materials.filter(material =>
            this.currentUpdateSalesOffice.distributionchaininherit
              .map((r) => r._id.toString())
              .includes(material._id.toString())
          );
          this.distributionMultiCtrl.setValue(selectedMaterials);
        });
      }

      // listen for search field value changes
      this.distributionMultiFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterDistribMulti();
          this.setToggleAllCheckboxStateDistrib();
        });
    } catch (err: any) {
      this.snackBar.open(
        err.error?.message || 'Error al obtener canales de distribución.',
        'Cerrar',
        { duration: 5000 }
      );
    }
  }

  protected filterDistribMulti() {
    if (!this.distributionChainList) {
      return;
    }
    // get the search keyword
    let search = this.distributionMultiFilterCtrl.value;
    if (!search) {
      this.filteredDistributionCache = this.distributionChainList;
      this.filteredDistribution.next(this.distributionChainList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredDistributionCache = this.distributionChainList.filter(
      (material) => {
        const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
        const codeMatches =
          material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
        return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
      }
    );
    this.filteredDistribution.next(this.filteredDistributionCache);
  }

  toggleSelectAllDistribution(selectAllValue: boolean) {
    this.filteredDistribution
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.distributionMultiCtrl.patchValue(val);
        } else {
          this.distributionMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateDistrib() {
    let filteredLength = 0;
    if (this.distributionMultiCtrl && this.distributionMultiCtrl.value) {
      this.filteredDistributionCache.forEach((el) => {
        if (this.distributionMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateDistrib =
        filteredLength > 0 &&
        filteredLength < this.filteredDistributionCache.length;
      this.isCheckedDistrib =
        filteredLength > 0 &&
        filteredLength === this.filteredDistributionCache.length;
    }
  }

  async openCreateModal(): Promise<void> {
    this.currentUpdateSalesOffice = null;
    this.currentUpdateSalesOfficeAddress = null; // Resetear DTO de edición
    this.currentCreateSalesOfficeAddress = null; // Resetear DTO de creación
    await this.ensureModalDataLoaded();
    this.isAddressValid = null;
    this.isAddressFormInitialized = false;
    this.currentCreateSalesOffice = this.initializeCreateSalesOffice();
    this.dialogRefAdd = this.dialog.open(this.addModal, {
      disableClose: true,
      width: "95%",
      maxWidth: "1000px",
      maxHeight: "90vh",
    });
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createSalesOffice());
    this.dialogRefAdd.afterClosed().subscribe((result) => {
      result;
    });
  }

  async openEditModal(salesOffice: SalesOfficeAttributes): Promise<void> {
    await this.ensureModalDataLoaded();
    this.isAddressValid = null;
    this.isAddressFormInitialized = false;

    this.currentUpdateSalesOffice = { ...salesOffice };

    // Convertir address a DTO si existe
    if (salesOffice.address) {
      this.currentUpdateSalesOfficeAddress = this.convertAddressAttributesToDTO(
        salesOffice.address
      );
    } else {
      this.currentUpdateSalesOfficeAddress = null;
    }

    if (!this.currentUpdateSalesOffice.plant) {
      this.currentUpdateSalesOffice.plant = { _id: null, name: "" };
    }
    if (this.currentUpdateSalesOffice.plant._id) {
      //this.fetchAllWarehouseByPlant(this.currentUpdateSalesOffice.plant._id.toString());
      await this.fetchAllWarehouse();
    }
    this.dialogRefEdit = this.dialog.open(this.editModal, {
      disableClose: true,
      width: "95%",
      maxWidth: "1000px",
      maxHeight: "90vh",
    });
    this.dialogRefEdit.afterClosed().subscribe((result) => {
      result;
    });
  }

  createSalesOffice(): void {
    this.currentCreateSalesOffice.plantId =
      this.currentCreateSalesOffice.plantId;
    this.currentCreateSalesOffice.warehouseIds =
      this.warehouseMultiCtrl.value.map((ware: WarehouseAttributes) =>
        ware._id.toString()
      );
    this.currentCreateSalesOffice.distributionChainsInheritIds =
      this.distributionMultiCtrl.value.map(
        (chain: DistributionChainAttributes) => chain._id.toString()
      );
    this.currentCreateSalesOffice.divisionIds =
      this.divisionMultiCtrl.value.map((div: DivisionAttributes) =>
        div._id.toString()
      );

    // Crear payload sin la propiedad address (la agregamos después si existe)
    const payload: ICreateSalesOffice = { ...this.currentCreateSalesOffice };

    // Si hay DTO de dirección, asignarlo; si es null, eliminar la propiedad
    if (this.currentCreateSalesOfficeAddress) {
      payload.address = this.currentCreateSalesOfficeAddress;
    } else {
      delete payload.address;
    }

    this.salesOfficeService.create(payload).subscribe({
      next: () => {
        this.snackBar.open("Registro creado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.findAllWithCount();
        this.dialogRefAdd.close(true);
      },
      error: (err) => {
        // Manejar errores específicos de validación
        const errorMessage = err.error.message || "Error al crear el registro";
        let detailedMessage = errorMessage;

        // Si hay errores de validación relacionados con dirección
        if (err.error.errors && Array.isArray(err.error.errors)) {
          const addressErrors = err.error.errors.filter(
            (e: any) =>
              e.field &&
              (e.field.includes("address") ||
                e.field.includes("latitude") ||
                e.field.includes("longitude") ||
                e.field.includes("location"))
          );

          if (addressErrors.length > 0) {
            detailedMessage =
              "Error en la dirección:\n" +
              addressErrors.map((e: any) => `- ${e.message}`).join("\n");
          }
        }

        this.snackBar.open(detailedMessage, "Cerrar", {
          duration: 5000,
        });
      },
    });
  }

  updateSalesOffice(id: string): void {
    if (this.currentUpdateSalesOffice) {
      // Excluir address del spread (es AddressAttributes, no compatible con UpdateSalesOfficeAddress)
      const { address: _, ...salesOfficeWithoutAddress } =
        this.currentUpdateSalesOffice;

      const updatedSalesOffice: IUpdateSalesOffice = {
        ...salesOfficeWithoutAddress,
        companyid: this.currentUpdateSalesOffice.company._id.toString(),
        officeGroupId: this.currentUpdateSalesOffice.officeGroup._id.toString(),
        distributionChainId:
          this.currentUpdateSalesOffice.distributionchain._id.toString(),
        divisionIds: this.divisionMultiCtrl.value.map(
          (div: DivisionAttributes) => div._id.toString()
        ),
        distributionChainsInheritIds: this.distributionMultiCtrl.value.map(
          (chain: DistributionChainAttributes) => chain._id.toString()
        ),
        warehouseIds: this.warehouseMultiCtrl.value.map(
          (ware: WarehouseAttributes) => ware._id.toString()
        ),
        plantId: this.currentUpdateSalesOffice.plant?._id?.toString() ?? null,
        name: this.currentUpdateSalesOffice.name,
        type: this.currentUpdateSalesOffice.type,
        statusId: this.currentUpdateSalesOffice.statusId,
      };

      // Si hay DTO de dirección, asignarlo; si es null, eliminar la propiedad
      if (this.currentUpdateSalesOfficeAddress) {
        updatedSalesOffice.address = this.currentUpdateSalesOfficeAddress;
      } else {
        delete updatedSalesOffice.address;
      }

      this.salesOfficeService.update(id, updatedSalesOffice).subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
          this.dialogRefEdit.close(true);
        },
        error: (err) => {
          // Manejar errores específicos de validación
          const errorMessage =
            err.error.message || "Error al actualizar el registro";
          let detailedMessage = errorMessage;

          // Si hay errores de validación relacionados con dirección
          if (err.error.errors && Array.isArray(err.error.errors)) {
            const addressErrors = err.error.errors.filter(
              (e: any) =>
                e.field &&
                (e.field.includes("address") ||
                  e.field.includes("latitude") ||
                  e.field.includes("longitude") ||
                  e.field.includes("location"))
            );

            if (addressErrors.length > 0) {
              detailedMessage =
                "Error en la dirección:\n" +
                addressErrors.map((e: any) => `- ${e.message}`).join("\n");
            }
          }

          this.snackBar.open(detailedMessage, "Cerrar", {
            duration: 5000,
          });
        },
      });
    }
  }

  onStatusChange(event: boolean, warehouse: SalesOfficeAttributes): void {
    const originalStatusId = warehouse.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedSalesOffice = { ...warehouse, statusId: updatedStatusId };

    this.salesOfficeService
      // @ts-ignore
      .update(warehouse._id.toString(), updatedSalesOffice)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          warehouse.statusId = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  openDeleteDialog(warehouse: SalesOfficeAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: warehouse, disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.delete(warehouse._id.toString()));
  }

  delete(id: string): void {
    this.salesOfficeService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }
  onDivisionSelectionChange(plantsId: string[]): void {
    if (this.currentUpdateSalesOffice) {
      this.currentUpdateSalesOffice.divisions = plantsId.map(
        (plantId) =>
          this.divisionList.find((sub) => sub._id.toString() === plantId)!
      );
    }
  }

  onwarehouseSelectionChange(warehouseIds: string[]): void {
    if (this.currentUpdateSalesOffice) {
      this.currentUpdateSalesOffice.warehouses = warehouseIds.map(
        (warehouseId) =>
          this.warehouseList.find((sub) => sub._id.toString() === warehouseId)!
      );
    }
  }

  ondistributionChainSelectionChange(distributionChainId: string): void {
    if (this.currentUpdateSalesOffice) {
      this.currentUpdateSalesOffice.distributionchain =
        this.distributionChainList.find(
          (price) => price._id.toString() === distributionChainId
        )!;
    }
  }
  ondistributionChainsSelectionChange(distributionChainId: string[]): void {
    if (this.currentUpdateSalesOffice) {
      this.currentUpdateSalesOffice.distributionchaininherit =
        distributionChainId.map(
          (chainId) =>
            this.distributionChainList.find(
              (sub) => sub._id.toString() === chainId
            )!
        );
    }
  }

  onCompanySelectionChange(companyid: string): void {
    if (this.currentUpdateSalesOffice) {
      this.currentUpdateSalesOffice.company = this.companyList.find(
        (price) => price._id.toString() === companyid
      )!;
    }
  }

  onofficeGroupSelectionChange(officeGroupId: string): void {
    if (this.currentUpdateSalesOffice) {
      this.currentUpdateSalesOffice.officeGroup = this.officeGroupList.find(
        (price) => price._id.toString() === officeGroupId
      )!;
    }
  }

  clearFilters(): void {
    this.selectedCompanyIds = [];
    this.form.reset({
      companyId: null,
      salesOfficeGroupId: null,
    });
    this.searchQuery = "";
    this.findAllWithCount();
  }
  private async loadPlants(): Promise<void> {
    try {
      const response = await firstValueFrom(this.plantService.findToComboBox());
      this.plants = response.data || [];
    } catch (err: any) {
      this.snackBar.open(err.error?.message || 'Error al obtener plantas', 'Cerrar', {
        duration: 5000,
      });
    }
  }
  private fetchAllWarehouseByPlant(plantId: string): void {
    this.warehouseService.findToComboBox(plantId).subscribe({
      next: (res) => {
        this.warehouseList = res.data;
        this.filteredWarehouses.next(this.warehouseList);

        this.filteredWarehouses.pipe(take(1)).subscribe((materials) => {
          const selectedMaterials = materials.filter((material) =>
            this.currentUpdateSalesOffice?.warehouses
              .map((r) => r._id.toString())
              .includes(material._id.toString())
          );
          this.warehouseMultiCtrl.setValue(selectedMaterials);
        });

        // Listen for search field value changes
        this.warehouseMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterWarehouseMulti();
            this.setToggleAllCheckboxStateWarehouse();
          });
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener almacenes por planta.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  onPlantSelectionChange(plantId: string): void {
    // Encuentra el objeto completo de la planta seleccionada
    const selectedPlant = this.plants.find((plant) => plant._id === plantId);

    // Actualiza el modelo según el contexto
    if (this.currentCreateSalesOffice) {
      this.currentCreateSalesOffice.plantId = selectedPlant?._id; // Actualiza el ID en la creación
    }
    if (this.currentUpdateSalesOffice) {
      this.currentUpdateSalesOffice.plant = selectedPlant; // Actualiza el objeto completo en la edición
    }
    if (plantId) {
      this.fetchAllWarehouseByPlant(plantId);
    } else {
      this.warehouseList = [];
      this.filteredWarehouses.next([]);
      this.warehouseMultiCtrl.setValue([]);
    }
  }

  //exportar
  onExportButtonPressed() {
    if (!this.salesOfficeExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: SALES_OFFICE_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.salesOfficeExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex
        );
      }
    });
  }

  onAddressChange(address: IAddressDTO): void {
    if (this.currentCreateSalesOffice) {
      // Convertir IAddressDTO a UpdateSalesOfficeAddress para creación
      this.currentCreateSalesOfficeAddress =
        this.convertIAddressDTOToUpdateDTO(address);
    }
    if (this.currentUpdateSalesOffice) {
      // Convertir IAddressDTO a UpdateSalesOfficeAddress para edición
      this.currentUpdateSalesOfficeAddress =
        this.convertIAddressDTOToUpdateDTO(address);
    }
  }

  // Manejar cambios de validez del formulario de dirección
  onAddressValidityChange(isValid: boolean): void {
    this.isAddressValid = isValid;
    // Marcar como inicializado la primera vez que se recibe un evento de validez
    if (!this.isAddressFormInitialized) {
      this.isAddressFormInitialized = true;
    }
  }

  // Verificar validez del formulario general (información general)
  checkGeneralFormValidity(form: any): boolean {
    return form && form.valid;
  }

  // Obtener mensaje tooltip cuando el botón de guardar está deshabilitado
  getDisabledTooltip(generalFormValid: boolean): string {
    const addressInvalid = this.isAddressValid === false;
    const addressNotInitialized = this.isAddressValid === null;

    if (addressNotInitialized) {
      return "Cargando información de dirección...";
    }

    if (!generalFormValid && addressInvalid) {
      return "Complete la información general y la dirección para guardar";
    } else if (!generalFormValid) {
      return "Complete todos los campos obligatorios de información general";
    } else if (addressInvalid) {
      return "Complete todos los campos obligatorios de la dirección";
    }
    return "";
  }

  // Manejar cambio de tab en modal crear
  onCreateTabChanged(index: number): void {
    this.selectedCreateTabIndex = index;
  }

  // Manejar cambio de tab en modal editar
  onEditTabChanged(index: number): void {
    this.selectedEditTabIndex = index;
  }

  // Helper: Convertir AddressAttributes a UpdateSalesOfficeAddress
  private convertAddressAttributesToDTO(
    address: AddressAttributes
  ): UpdateSalesOfficeAddress {
    return {
      name: address.name,
      address: address.address,
      _id: address._id?.toString() || null,
      reference: address.reference || "",
      postalCode: address.postalCode || "",
      contactName: address.contactName || "",
      isPrincipal: address.isPrincipal || false,
      statusId: address.statusId || 0,
      locationOneId: address.locationOne?._id?.toString() || "",
      locationTwoId: address.locationTwo?._id?.toString() || "",
      locationThreeId: address.locationThree?._id?.toString() || "",
      locationFourId: address.locationFour?._id?.toString() || null,
      latitude: address.geolocationPoint?.[0]?.toString() || "",
      longitude: address.geolocationPoint?.[1]?.toString() || "",
      typeId: address.type?._id?.toString() || "",
    };
  }

  // Helper: Convertir IAddressDTO a UpdateSalesOfficeAddress
  private convertIAddressDTOToUpdateDTO(
    dto: IAddressDTO
  ): UpdateSalesOfficeAddress {
    return {
      name: dto.name,
      address: dto.address,
      _id: dto._id || null,
      reference: dto.reference || "",
      postalCode: dto.postalCode || "",
      contactName: dto.contactName || "",
      isPrincipal: dto.isPrincipal || false,
      statusId: dto.statusId || 0,
      locationOneId: dto.locationOneId || "",
      locationTwoId: dto.locationTwoId || "",
      locationThreeId: dto.locationThreeId || "",
      locationFourId: dto.locationFourId || null,
      latitude: dto.latitude || "",
      longitude: dto.longitude || "",
      typeId: dto.typeId,
    };
  }

  // Validar si la dirección está completamente vacía
  private isAddressEmpty(address: IAddressDTO | null | undefined): boolean {
    if (!address) return true;

    return (
      !address.name &&
      !address.address &&
      !address.reference &&
      !address.locationOneId &&
      !address.locationTwoId &&
      !address.locationThreeId &&
      !address.postalCode &&
      !address.contactName &&
      !address.latitude &&
      !address.longitude
    );
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  //#region  Sales Office Phones

  onPhoneChanged(email: EmailAttributes) {
    if (email._id) {
      // Edición
      this.updatePhone(email);
    } else {
      // Creación
      this.createPhone(email);
    }
  }

  createPhone(result): void {
    this.salesOfficePhoneService
      .createEmbedded(this.currentUpdateSalesOffice._id.toString(), result)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.salesOfficePhoneService
            .findBySalesOfficeId(this.currentUpdateSalesOffice._id.toString())
            .subscribe((data) => {
              this.currentUpdateSalesOffice.phones = data?.data;
              if (this.currentCreateSalesOffice) {
                this.currentCreateSalesOffice.phones = data?.data;
              }
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  updatePhone(result): void {
    this.salesOfficePhoneService
      .updateEmbedded(
        this.currentUpdateSalesOffice._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.salesOfficePhoneService
            .findBySalesOfficeId(this.currentUpdateSalesOffice._id.toString())
            .subscribe((data) => {
              this.currentUpdateSalesOffice.phones = data?.data;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  onPhoneDeleted(phone: PhoneAttributes) {
    if (!phone._id) return;

    this.salesOfficePhoneService
      .deleteEmbedded(
        this.currentUpdateSalesOffice._id.toString(),
        phone._id.toString(),
        phone
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Email eliminado con éxito", "Cerrar", {
            duration: 3000,
          });

          this.currentUpdateSalesOffice.phones =
            this.currentUpdateSalesOffice.phones.filter(
              (e) => e._id !== phone._id
            );
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al eliminar",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  onPhoneStatusChanged(event: { phone: PhoneAttributes; newStatus: boolean }) {
    const { phone, newStatus } = event;
    const originalStatusId = phone.statusId;
    const updatedStatusId = newStatus ? 1 : 0;

    const updatedPhone = { ...phone, statusId: updatedStatusId };

    this.salesOfficePhoneService
      .updateEmbedded(
        this.currentUpdateSalesOffice._id.toString(),
        phone._id.toString(),
        updatedPhone
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.salesOfficePhoneService
            .findBySalesOfficeId(this.currentUpdateSalesOffice._id.toString())
            .subscribe((data) => {
              this.currentUpdateSalesOffice.phones = data?.data;
              if (this.currentCreateSalesOffice) {
                this.currentCreateSalesOffice.phones = data?.data;
              }
            });
        },
        error: () => {
          phone.statusId = originalStatusId; // revertir UI
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.salesOfficePhoneService
            .findBySalesOfficeId(this.currentUpdateSalesOffice._id.toString())
            .subscribe((data) => {
              this.currentUpdateSalesOffice.phones = data?.data;
              if (this.currentCreateSalesOffice) {
                this.currentCreateSalesOffice.phones = data?.data;
              }
            });
        },
      });
  }

  //#endregion

  //#region Sales Office Emails

  onEmailChanged(email: EmailAttributes) {
    if (email._id) {
      // Edición
      this.updateEmail(email);
    } else {
      // Creación
      this.createEmail(email);
    }
  }

  createEmail(result): void {
    this.salesOfficeEmailService
      .createEmbedded(this.currentUpdateSalesOffice._id.toString(), result)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.salesOfficeEmailService
            .findBySalesOfficeId(this.currentUpdateSalesOffice._id.toString())
            .subscribe((data) => {
              this.currentUpdateSalesOffice.emails = data?.data;
              if (this.currentCreateSalesOffice) {
                this.currentCreateSalesOffice.emails = data?.data;
              }
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  updateEmail(result): void {
    this.salesOfficeEmailService
      .updateEmbedded(
        this.currentUpdateSalesOffice._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.salesOfficeEmailService
            .findBySalesOfficeId(this.currentUpdateSalesOffice._id.toString())
            .subscribe((data) => {
              this.currentUpdateSalesOffice.emails = data?.data;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  onEmailDeleted(email: EmailAttributes) {
    if (!email._id) return;

    this.salesOfficeEmailService
      .deleteEmbedded(
        this.currentUpdateSalesOffice._id.toString(),
        email._id.toString(),
        email
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Email eliminado con éxito", "Cerrar", {
            duration: 3000,
          });

          this.currentUpdateSalesOffice.emails =
            this.currentUpdateSalesOffice.emails.filter(
              (e) => e._id !== email._id
            );
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al eliminar",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  onEmailStatusChanged(event: { email: EmailAttributes; newStatus: boolean }) {
    const { email, newStatus } = event;
    const originalStatusId = email.statusId;
    const updatedStatusId = newStatus ? 1 : 0;

    const updatedEmail = { ...email, statusId: updatedStatusId };

    this.salesOfficeEmailService
      .updateEmbedded(
        this.currentUpdateSalesOffice._id.toString(),
        email._id.toString(),
        updatedEmail
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.salesOfficeEmailService
            .findBySalesOfficeId(this.currentUpdateSalesOffice._id.toString())
            .subscribe((data) => {
              this.currentUpdateSalesOffice.emails = data?.data;
              if (this.currentCreateSalesOffice) {
                this.currentCreateSalesOffice.emails = data?.data;
              }
            });
        },
        error: () => {
          email.statusId = originalStatusId;
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.salesOfficeEmailService
            .findBySalesOfficeId(this.currentUpdateSalesOffice._id.toString())
            .subscribe((data) => {
              this.currentUpdateSalesOffice.emails = data?.data;
              if (this.currentCreateSalesOffice) {
                this.currentCreateSalesOffice.emails = data?.data;
              }
            });
        },
      });
  }
  //#endregion
}
